import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CheckCircle as CheckIcon } from "@mui/icons-material";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
import { SequenceFlow } from "model/activitiesModel";
import { getTranslation } from "common";

interface MobileSequenceFlowsInlineProps {
  flows: SequenceFlow[];
  onChoose: (flow: SequenceFlow) => void;
  translations: Record<string, string>;
}

/**
 * Inline list of sequence flow buttons.
 * Replaces the SequenceFlowsDialog on mobile: tapping a flow invokes the transition
 * directly (no modal interruption). The available transitions are pulled from
 * `task.sequenceflows` already provided by the parent (TaskDetailDialog).
 */
const MobileSequenceFlowsInline: React.FC<MobileSequenceFlowsInlineProps> = ({
  flows,
  onChoose,
  translations,
}) => {
  if (flows.length === 0) {
    return null;
  }

  return (
    <Stack spacing={0.75}>
      <Typography
        variant="caption"
        sx={{
          fontSize: 9,
          fontWeight: 700,
          color: "text.secondary",
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        {getTranslation(translations, "process.action.done")}
      </Typography>
      <Stack spacing={0.5}>
        {flows.map((flow) => (
          <FlowentiButton
            key={flow.id}
            id={`mobile-sequenceflow-${flow.id}`}
            size="small"
            variant="outlined"
            startIcon={<CheckIcon sx={{ fontSize: 12, color: "success.main" }} />}
            onClick={() => onChoose(flow)}
            sx={{
              justifyContent: "space-between",
              fontSize: 10,
              fontWeight: 700,
              py: 0.5,
              px: 1,
              borderRadius: 1.5,
              borderColor: "success.light",
              color: "success.dark",
              bgcolor: (t) => (t.palette.mode === "dark" ? "background.default" : "success.50"),
              "&:hover": {
                bgcolor: (t) => (t.palette.mode === "dark" ? "action.hover" : "success.100"),
              },
            }}
          >
            <Box component="span" sx={{ textAlign: "left", flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {flow.name}
            </Box>
          </FlowentiButton>
        ))}
      </Stack>
    </Stack>
  );
};

export default MobileSequenceFlowsInline;